/* ============================================================
   LUXE PARIS — Theme JS (vanilla, lightweight, no dependencies)
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Header scroll state ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile nav drawer ---------- */
  var burger = document.querySelector('[data-nav-toggle]');
  var drawer = document.querySelector('.nav-drawer');
  var overlay = document.querySelector('.drawer-overlay');
  function closeDrawer() {
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (burger && drawer) {
    burger.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      if (overlay) overlay.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keyup', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- Reveal on scroll ---------- */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Product gallery ---------- */
  var galleries = document.querySelectorAll('[data-gallery]');
  galleries.forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        var alt = thumb.getAttribute('data-alt') || '';
        if (mainImg && full) { mainImg.src = full; mainImg.alt = alt; }
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- Quantity selectors ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.getAttribute('data-qty-change') === 'up' ? 1 : -1;
        var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- Sticky add to cart ---------- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var formAtc = document.querySelector('[data-product-form] [type="submit"]');
  if (stickyBar && formAtc) {
    var stickyIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    stickyIO.observe(formAtc);

    var stickyBtn = stickyBar.querySelector('[data-sticky-submit]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var realForm = document.querySelector('[data-product-form]');
        if (realForm && realForm.requestSubmit) realForm.requestSubmit();
        else if (realForm) realForm.querySelector('[type="submit"]').click();
      });
    }
  }

  /* ---------- Cart count refresh ---------- */
  function refreshCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.setAttribute('data-count', cart.item_count);
          el.textContent = cart.item_count;
        });
      }).catch(function () {});
  }

  /* ---------- AJAX add to cart (product + sticky forms) ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (form.getAttribute('data-ajax') !== 'true') return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.textContent = btn.getAttribute('data-adding') || 'Adding…'; btn.disabled = true; }
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          refreshCartCount();
          if (btn) { btn.textContent = btn.getAttribute('data-added') || 'Added ✓'; }
          setTimeout(function () { if (btn) { btn.textContent = original; btn.disabled = false; } }, 1600);
        })
        .catch(function () {
          if (btn) { btn.textContent = original; btn.disabled = false; }
          form.submit();
        });
    });
  });

})();
